import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=26366f2b&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=26366f2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26366f2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26366f2b')) {
      api.createRecord('26366f2b', component.options)
    } else {
      api.reload('26366f2b', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=26366f2b&scoped=true&", function () {
      api.rerender('26366f2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2j2ErrNOOJZ0V/JS/comp/PopupBox.vue"
export default component.exports